import React from "react";
import { ASSETS } from "@/data/content";
import { useI18n } from "@/i18n";

export default function Footer() {
  const { t, site } = useI18n();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-canvas border-t border-ink/10 py-16 md:py-20 overflow-hidden"
    >
      <img
        src={ASSETS.logo}
        alt=""
        aria-hidden="true"
        data-testid="footer-watermark"
        className="pointer-events-none select-none absolute -right-24 -bottom-32 w-[420px] md:w-[560px] opacity-[0.06] grayscale"
      />
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="grid grid-cols-12 gap-8 md:gap-16 items-center">
          <div className="col-span-12 md:col-span-5 flex items-center gap-4">
            <img src={ASSETS.logo} alt="Logo PrzyStań w ciszy" className="h-24 w-auto object-contain" />
            <div>
              <p className="serif text-2xl text-ink font-light">{site.name}</p>
              <p className="text-ink-muted text-xs tracking-[0.25em] uppercase">
                {site.location}
              </p>
            </div>
          </div>

          <div className="col-span-12 md:col-span-7 md:text-right flex flex-col md:items-end gap-2">
            <p className="serif italic text-xl md:text-2xl text-ink-muted">
              {t.hero.tagline}
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row md:justify-between gap-4 text-xs text-ink-muted tracking-wide">
          <p>© {new Date().getFullYear()} {site.name}. {t.footer.rights}</p>
          <p className="uppercase tracking-[0.25em]">{t.footer.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
